export type UnitSystem = "metric" | "imperial";

type UnitToggleProps = {
  value: UnitSystem;
  onChange: (value: UnitSystem) => void;
  className?: string;
  metricLabel?: string;
  imperialLabel?: string;
};

const UnitToggle = ({
  value,
  onChange,
  className = "",
  metricLabel = "Metric",
  imperialLabel = "Imperial",
}: UnitToggleProps) => {
  const baseBtn =
    "flex-1 px-3 py-[15.5px] text-sm font-semibold transition focus:outline-none text-[15.2px] rounded-[10px]";
  const activeBtn = "bg-white text-primary";
  const inactiveBtn = "bg-bg-dark text-primary";

  return (
    <div
      className={[
        "flex w-full overflow-hidden rounded-[10px] p-1 gap-1 max-w-100 bg-bg-dark",
        className,
      ].join(" ")}
    >
      <button
        type="button"
        onClick={() => onChange("metric")}
        className={[baseBtn, value === "metric" ? activeBtn : inactiveBtn].join(
          " ",
        )}
      >
        {metricLabel}
      </button>

      <button
        type="button"
        onClick={() => onChange("imperial")}
        className={[
          baseBtn,
          value === "imperial" ? activeBtn : inactiveBtn,
        ].join(" ")}
      >
        {imperialLabel}
      </button>
    </div>
  );
};

export default UnitToggle;
